import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useInView } from 'react-intersection-observer';
import cc from 'classcat';
import PropTypes from 'prop-types';
import Carousel from './Carousel';
import CarouselLoading from './CarouselLoading';
import css from './Carousel.module.scss';
/* eslint-disable react/destructuring-assignment */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ImageCarousel = function ImageCarousel(_ref) {
  var items = _ref.items,
      name = _ref.name,
      removeOuterMargins = _ref.removeOuterMargins;

  var _useInView = useInView({
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      inViewRef = _useInView2[0],
      inView = _useInView2[1];

  if (!items.length) {
    return false;
  }

  return /*#__PURE__*/_jsxs("section", {
    className: cc([css.root, _defineProperty({}, css.removeOuterMargins, removeOuterMargins)]),
    ref: inViewRef,
    "data-testid": "rootInView",
    children: [inView && /*#__PURE__*/_jsx(Carousel, {
      items: items,
      name: name
    }), !inView && /*#__PURE__*/_jsx(CarouselLoading, {
      item: items[0]
    })]
  });
};

ImageCarousel.defaultProps = {
  items: [],
  name: '',
  removeOuterMargins: false
};
ImageCarousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.shape({
      id: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired
    })
  }).isRequired).isRequired,
  name: PropTypes.string.isRequired,
  removeOuterMargins: PropTypes.bool.isRequired
};
export default ImageCarousel;